import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h4>{`Nol Pay`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Recovery Suggestion`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`nol-pay-sdk-error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when there is an error returned by Nol Pay. Errors can be distinguished by `}<inlineCode parentName="td">{`errorCode`}</inlineCode>{`:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Specific recovery suggestions based on the `}<inlineCode parentName="td">{`errorCode`}</inlineCode>{`:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3300`}</inlineCode>{`: Failed to init Transit SDK`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3300`}</inlineCode>{`: Ensure the Transit SDK is correctly initialized and try again.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3301`}</inlineCode>{`: Error on request parameter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3301`}</inlineCode>{`: Contact Primer and provide us with diagnostics id.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3302`}</inlineCode>{`: Network error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3302`}</inlineCode>{`: Check network connection and retry.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3304`}</inlineCode>{`: Failed to handle response payload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3304`}</inlineCode>{`: Contact Primer and provide us with diagnostics id.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3305`}</inlineCode>{`: API call failed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3305`}</inlineCode>{`: Contact Primer and provide us with diagnostics id.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3310`}</inlineCode>{`: Mobile phone does not support NFC`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3310`}</inlineCode>{`: Ensure the mobile phone supports NFC and retry.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3311`}</inlineCode>{`: NFC disabled on mobile phone`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3311`}</inlineCode>{`: Enable NFC on the mobile phone and retry.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3312`}</inlineCode>{`: Invalid NFC Tag`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3312`}</inlineCode>{`: Verify the NFC tag and retry.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3313`}</inlineCode>{`: NFC disconnected, user should hold Nol card until scanning finishes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3313`}</inlineCode>{`: Hold the Nol card steady until scanning finishes.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3314`}</inlineCode>{`: NFC Command error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- `}<inlineCode parentName="td">{`A3314`}</inlineCode>{`: Contact Primer and provide us with diagnostics id.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      